import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MobileLayout } from '../../components/MobileLayout';
import { Tabs } from '../../components/ui/Tabs';
import { Card, CardContent, CardFooter } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Clock, MapPin, Home, ChevronRight, Check } from 'lucide-react';
import { useMaintenance, MaintenanceJob, JobStatus } from '../../context/MaintenanceContext';
const statusMap: Record<JobStatus, {
  label: string;
  cls: string;
}> = {
  da_accettare: {
    label: 'Da accettare',
    cls: 'bg-amber-50 text-amber-700 border-amber-200'
  },
  accettata: {
    label: 'Accettata',
    cls: 'bg-muted text-muted-foreground border-border'
  },
  in_corso: {
    label: '● In corso',
    cls: 'bg-coral/5 text-coral border-coral/20'
  },
  completata: {
    label: 'Completata',
    cls: 'bg-emerald-50 text-emerald-700 border-emerald-200'
  }
};
export function ManIncarichiPage() {
  const navigate = useNavigate();
  const {
    jobs,
    acceptJob
  } = useMaintenance();
  const [tab, setTab] = useState('attivi');
  const visible = jobs.filter(j => tab === 'attivi' ? j.status !== 'completata' : j.status === 'completata');
  return <MobileLayout data-id="element-3309">
      <div className="mb-6" data-id="element-3310">
        <h1 className="text-xl lg:text-2xl font-bold text-navy" data-id="element-3311">Incarichi</h1>
        <p className="text-sm text-muted-foreground mt-0.5" data-id="element-3312">
          Gestisci i tuoi interventi e tieni traccia di quelli completati.
        </p>
      </div>
      <Tabs className="mb-6" value={tab} onValueChange={setTab} items={[{
      id: 'attivi',
      label: 'Attivi'
    }, {
      id: 'completati',
      label: 'Completati'
    }]} data-id="element-3313" />
      {visible.length > 0 ? <div className="space-y-3" data-id="element-3314">
          {visible.map(j => <Card key={j.id} className="hover:border-coral/40 hover:shadow-sm transition-all" data-id="element-3315">
              <CardContent className="flex items-center justify-between gap-3 cursor-pointer" onClick={() => navigate(`/man/incarichi/${j.id}`)} data-id="element-3316">
                <div className="min-w-0" data-id="element-3317">
                  <div className="flex items-center gap-2 mb-1" data-id="element-3318">
                    <h3 className="text-sm font-semibold text-foreground truncate" data-id="element-3319">
                      {j.title}
                    </h3>
                    <span className={`text-[10px] font-medium px-2 py-0.5 rounded-full border flex-shrink-0 ${statusMap[j.status].cls}`} data-id="element-3320">
                      {statusMap[j.status].label}
                    </span>
                  </div>
                  <div className="flex items-center gap-3 text-xs text-muted-foreground flex-wrap" data-id="element-3321">
                    <span className="flex items-center gap-1" data-id="element-3322">
                      <Home size={12} data-id="element-3323" />
                      {j.trade}
                    </span>
                    <span className="flex items-center gap-1" data-id="element-3324">
                      <MapPin size={12} data-id="element-3325" />
                      {j.zone}
                    </span>
                    <span className="flex items-center gap-1" data-id="element-3326">
                      <Clock size={12} data-id="element-3327" />
                      {j.date} · {j.time}
                    </span>
                    <span className="font-semibold text-foreground" data-id="element-3328">
                      €{j.earning}
                    </span>
                  </div>
                </div>
                <ChevronRight size={16} className="text-muted-foreground flex-shrink-0" data-id="element-3329" />
              </CardContent>
              {j.status === 'da_accettare' && <CardFooter data-id="element-3330">
                  <span className="text-xs text-muted-foreground" data-id="element-3331">
                    {j.property}
                  </span>
                  <Button size="sm" onClick={() => acceptJob(j.id)} data-id="element-3332">
                    <Check size={15} data-id="element-3333" />
                    Accetta
                  </Button>
                </CardFooter>}
            </Card>)}
        </div> : <div className="bg-white border border-border rounded-xl p-10 text-center" data-id="element-3334">
          <div className="w-12 h-12 rounded-full bg-muted flex items-center justify-center mx-auto mb-3" data-id="element-3335">
            <Clock size={20} className="text-muted-foreground" data-id="element-3336" />
          </div>
          <p className="text-sm font-medium text-foreground" data-id="element-3337">
            {tab === 'attivi' ? 'Nessun incarico attivo' : 'Nessun incarico completato'}
          </p>
          <p className="text-xs text-muted-foreground mt-1" data-id="element-3338">
            {tab === 'attivi' ? 'Accetta opportunità di zona per riempire la tua agenda.' : 'Gli interventi completati appariranno qui.'}
          </p>
        </div>}
    </MobileLayout>;
}